/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-11-ge6c01455-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExistingCertificateCredentialFromJSON, ExistingCertificateCredentialToJSON, } from './ExistingCertificateCredential';
/**
 * Check if a given object implements the IssuedCertificateCredential interface.
 */
export function instanceOfIssuedCertificateCredential(value) {
    if (!('credential' in value) || value['credential'] === undefined)
        return false;
    if (!('certificatePem' in value) || value['certificatePem'] === undefined)
        return false;
    return true;
}
export function IssuedCertificateCredentialFromJSON(json) {
    return IssuedCertificateCredentialFromJSONTyped(json, false);
}
export function IssuedCertificateCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'credential': ExistingCertificateCredentialFromJSON(json['credential']),
        'certificatePem': json['certificate_pem'],
    };
}
export function IssuedCertificateCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'credential': ExistingCertificateCredentialToJSON(value['credential']),
        'certificate_pem': value['certificatePem'],
    };
}
